import { ref } from "vue";
import { locale } from "../locale";

export function getEmptyFieldValidator(fieldname: string) {
  let state = ref(true);
  return {
    validator: (val: string) => {
      if (val.length > 0) {
        state.value = true;
        return true;
      } else {
        state.value = false;
        return `${fieldname} ${locale.validators.messages.empty}`;
      }
    },
    state,
  };
}

export function getMaxLenValidator(len: number, fieldname: string) {
  let state = ref(true);
  return {
    validator: (val: string) => {
      if (val.length <= len) {
        state.value = true;
        return true;
      } else {
        state.value = false;
        return `${fieldname} ${locale.validators.messages.maxLen} ${len} ${locale.validators.messages.symbols}`;
      }
    },
    state,
  };
}

export function combineValidators(validators: validator[]) {
  let state = ref(true);
  return {
    validator: (val: string) => {
      for (const validator of validators) {
        let check = validator(val);
        if (check !== true) {
          state.value = false;
          return check;
        }
      }
      state.value = true;
      return true;
    },
    state,
  };
}

type validator = (val: string) => boolean | string;
